import { render, staticRenderFns } from "./play-34.vue?vue&type=template&id=53045c68&scoped=true"
import script from "./play-34.vue?vue&type=script&lang=js"
export * from "./play-34.vue?vue&type=script&lang=js"
import style0 from "./play-34.vue?vue&type=style&index=0&id=53045c68&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53045c68",
  null
  
)

export default component.exports